import { Trash } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import ProfileImage from "common/components/ui/ProfileImage";

interface BlacklistItemProps {
  title: string;
  subtitle: string;
  pictureUrl: string;
  onRemove: () => void;
}

export default function BlacklistItem({
  title,
  subtitle,
  pictureUrl,
  onRemove,
}: BlacklistItemProps) {
  return (
    <div className="flex flex-row items-center justify-between rounded-3xl border border-black-200 p-3">
      <div className="flex flex-row items-center gap-3">
        <ProfileImage size="md" src={pictureUrl} />

        <div className="flex flex-col gap-0.5">
          <span className="text-sm-bold">{title}</span>
          <span className="line-clamp-1 text-xs-medium text-black-500">
            {subtitle}
          </span>
        </div>
      </div>

      <Button
        intent="iconOnly"
        variant="ghost-danger"
        onClick={onRemove}
        size="sm"
        data-cy="remove-from-blacklist-button"
      >
        <Trash />
      </Button>
    </div>
  );
}
